import { render, staticRenderFns } from "./EventItemDelivery.vue?vue&type=template&id=c929651e&"
import script from "./EventItemDelivery.vue?vue&type=script&lang=js&"
export * from "./EventItemDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports